import { render, staticRenderFns } from "./item_row.vue?vue&type=template&id=39e58415&"
import script from "./item_row.vue?vue&type=script&lang=js&"
export * from "./item_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports